import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { LinkedService } from './linkedservice';
import { format } from '../../shared/utils/string.util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.dataQualityLinkedService,
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, shellStringResources.DataQualityLabel),
        format(shellStringResources.ModelName_LinkedServicesTemplate, shellStringResources.DataQualityLabel)
    ]
})
export class DataQualityLinkedService extends LinkedService { }
